module.exports = __webpack_public_path__ + "static/media/vf_msneakers_core.e5493485.svg";